__webpack_require__.p = "https://drgadget.xperd.id/";